import { ActionTypes, LineWatchdogSettingActions } from './line-watchdog-settings.actions';
import { LineWatchdogSettingState } from './line-watchdog-settings.model';

export const lineWatchdogSettingState: LineWatchdogSettingState = {
  tableDataLoading: false,
  tableDataLoaded: false,
  tableData: [],
  tablePageInfo: {
    page: 1,
    pageCount: 0,
    total: 0,
  },
  getLineWatchdogSettingLoading: false,
  getLineWatchdogSettingLoaded: false,
  lineWatchdogSetting: null,
  addLineWatchdogSettingLoading: false,
  addLineWatchdogSettingLoaded: false,
  editLineWatchdogSettingLoading: false,
  editLineWatchdogSettingLoaded: false,
  deleteLineWatchdogSettingsLoading: false,
  deleteLineWatchdogSettingsLoaded: false,
  siteDataLoading: false,
  siteDataLoaded: false,
  siteData: [],
  lineDataLoading: false,
  lineDataLoaded: false,
  lineData: null,
  activitiesDataLoading: false,
  activitiesDataLoaded: false,
  activitiesData: [],
};

export function lineWatchdogSettingReducer(
  state: LineWatchdogSettingState = lineWatchdogSettingState,
  action: LineWatchdogSettingActions,
): LineWatchdogSettingState {
  switch (action.type) {
    case ActionTypes.LINE_WATCHDOG_SETTINGS_DATA_LOADING:
      return {
        ...state,
        tableDataLoading: true,
        tableDataLoaded: false,
      };
    case ActionTypes.LINE_WATCHDOG_SETTINGS_DATA_LOADED:
      return {
        ...state,
        tableData: action.payload.data,
        tablePageInfo: {
          page: action.payload.page,
          pageCount: action.payload.pageCount,
          total: action.payload.total,
        },
        tableDataLoading: false,
        tableDataLoaded: true,
      };
    case ActionTypes.GET_LINE_WATCHDOG_SETTING:
      return {
        ...state,
        getLineWatchdogSettingLoading: true,
        getLineWatchdogSettingLoaded: false,
      };
    case ActionTypes.GET_LINE_WATCHDOG_SETTING_COMPLETED:
      return {
        ...state,
        lineWatchdogSetting: action.payload.data,
        getLineWatchdogSettingLoading: false,
        getLineWatchdogSettingLoaded: true,
      };
    case ActionTypes.ADD_LINE_WATCHDOG_SETTING:
      return {
        ...state,
        addLineWatchdogSettingLoading: true,
        addLineWatchdogSettingLoaded: false,
      };
    case ActionTypes.ADD_LINE_WATCHDOG_SETTING_COMPLETED:
      return {
        ...state,
        addLineWatchdogSettingLoading: false,
        addLineWatchdogSettingLoaded: true,
      };
    case ActionTypes.EDIT_LINE_WATCHDOG_SETTING:
      return {
        ...state,
        editLineWatchdogSettingLoading: true,
        editLineWatchdogSettingLoaded: false,
      };
    case ActionTypes.EDIT_LINE_WATCHDOG_SETTING_COMPLETED:
      return {
        ...state,
        editLineWatchdogSettingLoading: false,
        editLineWatchdogSettingLoaded: true,
      };
    case ActionTypes.DELETE_LINE_WATCHDOG_SETTINGS:
      return {
        ...state,
        deleteLineWatchdogSettingsLoading: true,
        deleteLineWatchdogSettingsLoaded: false,
      };
    case ActionTypes.DELETE_LINE_WATCHDOG_SETTINGS_COMPLETED:
      return {
        ...state,
        deleteLineWatchdogSettingsLoading: false,
        deleteLineWatchdogSettingsLoaded: true,
      };
    case ActionTypes.SITES_DATA_LOADING:
      return {
        ...state,
        siteDataLoading: true,
        siteDataLoaded: false,
      };
    case ActionTypes.SITES_DATA_COMPLETED:
      return {
        ...state,
        siteData: action.payload,
        siteDataLoading: false,
        siteDataLoaded: true,
      };
    case ActionTypes.LINES_DATA_LOADING:
      return {
        ...state,
        lineDataLoading: true,
        lineDataLoaded: false,
      };
    case ActionTypes.LINES_DATA_COMPLETED:
      return {
        ...state,
        lineData: action.payload,
        lineDataLoading: false,
        lineDataLoaded: true,
      };
    case ActionTypes.ACTIVITIES_DATA_LOADING:
      return {
        ...state,
        activitiesDataLoading: true,
        activitiesDataLoaded: false,
      };
    case ActionTypes.ACTIVITIES_DATA_COMPLETED:
      return {
        ...state,
        activitiesData: action.payload,
        activitiesDataLoading: false,
        activitiesDataLoaded: true,
      };
    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
}
